$(document).ready(function() {

        var lastMediaTrigger;
        var mediaMode = 'single';
        var mediaCallback = null;
        var lastSelected = null;

        $('#mediaModal .mmdropzone').each(function(){
            $(this).removeClass('mmdropzone').addClass('minitdropzone');
            var $previewTarget = $(this).parent().find('.'+$(this).data('preview')).first();
            // console.log($previewTarget);
            if ($previewTarget.length) {
                //console.log('preview target');
                $previewTarget.uniqueId();
                $(this).attr('data-preview', $previewTarget.attr("id"));
            }
            $(this).uniqueId();
            var widgetId = 'mediawidget';
            $(this).attr("id", widgetId);
            window.initDropzone('#'+widgetId);
        });


    // $('.selectable-image').on('click', function (e) {
     $(document).on('click', '.selectable-image',function(e){
        if (mediaMode === 'single'){
            $('.selectable-image').removeClass('selected');
        }
        $(this).toggleClass('selected');
        if ($(this).hasClass('selected')){ lastSelected = $(this);}
    });

    $(document).on('click', '.unsplash-selected',function(e){

        if (mediaMode === 'single'){
            $('.unsplash-selected').removeClass('selected');
        }
        $(this).toggleClass('selected');
        if ($(this).hasClass('selected')){ lastSelected = $(this);}

    });

    $(document).on('dblclick', '.selectable-image',function(e){
        // $('.selectable-image').on('dblclick', function () {
            const imageData = {
                url: $(this).data('url'),
                id: $(this).data('id')
            };

            // var returntarget = $('#mediaModal').attr('data-return');
            $(lastMediaTrigger).find('img').attr('src', $(this).data('url'));
            $(lastMediaTrigger).find('[name=image_id]').attr('value', $(this).data('id'));

            // $(document).trigger('image:selected', imageData);
            $('#mediaModal').modal('hide');
        });

        $(document).on('dblclick', '.unsplash-selected',function(e) {
            const imageData = {
                url: $(this).find('img').attr('download'),
                alt :$(this).find('img').attr('alt')
            };



            // var returntarget = $('#mediaModal').attr('data-return');
            $(lastMediaTrigger).find('img').attr('src',$(this).find('img').attr('replace'));
            $(lastMediaTrigger).find('.image-return').attr('value', 0);

            // $(document).trigger('image:selected', imageData);
            $('#mediaModal').modal('hide');

            $.post('/admin/unsplashimage', imageData)
                .done(function(data){
                    //$(lastMediaTrigger).find('.image-return').attr('value', data.image_id);
                    $(lastMediaTrigger).find('[name=image_id]').attr('value',  data.image_id);
                })
                .fail(function(){

                })
                .always(function(){

                });

        });

        function setMediaMode(mediaMode)
        {

        }

        $(document).on('click', '.mediamodaltrigger',function(e) {
            e.preventDefault();
            // var returntarget = '#'+$(this).closest('.tp-widget').attr('id');
            lastMediaTrigger = this;
            mediaMode = 'single';
            mediaCallback = null;

            if ($(this).data('mode')!==undefined) {
                mediaMode = $(this).data('mode');
                setMediaMode(mediaMode);
            }

            if ($(this).data('callback')!==undefined) {
                mediaCallback = $(this).data('callback');

            }

            $('.selectable-image').removeClass('selected');
            $('#mediaModal').modal('show');
        });


        $(document).on('click','.btn-media-selected', function(e){
            e.preventDefault();

            if (mediaMode == 'single'){
                lastSelected.trigger('dblclick');
            }else {
                var imagesData = [];
                $('.selectable-image.selected').each(function () {
                    imagesData.push({url: $(this).data('url'), id: $(this).data('id')});
                });

                if (mediaCallback) window[mediaCallback](imagesData);
            }
        });



        $(document).on('dblclick','.selectable-image', function (e) {
            const imageData = {
                url: $(this).data('url'),
                id: $(this).data('id')
            };

            // var returntarget = $('#mediaModal').attr('data-return');
            $(lastMediaTrigger).find('img').attr('src', $(this).data('url'));
            $(lastMediaTrigger).find('.image-return').attr('value', $(this).data('id'));

            // $(document).trigger('image:selected', imageData);
            $('#mediaModal').modal('hide');
        });






        /*media unsplash*/
        const UNSPLASH_ACCESS_KEY = 'rW_P7j-V7up92Bwu8KKljAo2E6XwPKxysdqW7rnWgDM';

        // document.getElementById('unsplashSearch').addEventListener('click', () => {
        //     const query = document.getElementById('unsplashSearch').value.trim();
        //     if (!query) return;
        //     searchUnsplash(query);
        // });

        var lastQuery = '';
        var lastQueryPage = 1;

        searchUnsplash('modern interior',1);
        $('#unsplashSearch').keydown(function(e) {
            if (e.which === 13) { // 13 is the Enter key code
                const query = document.getElementById('unsplashSearch').value.trim();
                if (!query) return;
                searchUnsplash(query, 1);
            }
        });

        async function searchUnsplash(query, page) {
            lastQuery = query;
            lastQueryPage = page;
            console.log('Page:'+page);
            const url = `https://api.unsplash.com/search/photos?query=${encodeURIComponent(query)}&w=120&h=120&fit=1&per_page=24&page=${page}&client_id=${UNSPLASH_ACCESS_KEY}`;

            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const data = await res.json();

                displayResults(data.results);
            } catch (e) {
                //console.error('Search error:', e);
                //alert('Error searching images.');
            }
        }

        $('#unsplash-load-more').on('click', function(e){
           e.preventDefault();
           searchUnsplash(lastQuery, lastQueryPage+1);
        });


        function displayResults(images) {
            const container = document.getElementById('unsplashResults');
            if (lastQueryPage==1) container.innerHTML = '';

            images.forEach(img => {
                const card = document.createElement('div');
                card.className = 'ppt-image-box  image-card unsplash-selected';

                const imgwrapper = document.createElement('div');
                imgwrapper.className = 'width-100';

                const imageEl = document.createElement('img');
                imageEl.src = img.urls.thumb;
                imageEl.alt = img.alt_description || 'Unsplash Image';
                imageEl.setAttribute('download',img.links.download_location + `?client_id=${UNSPLASH_ACCESS_KEY}`);
                imageEl.setAttribute('replace',img.urls.full + `?client_id=${UNSPLASH_ACCESS_KEY}`);
                imageEl.className = "img-responsive";


                imgwrapper.appendChild(imageEl);
                card.appendChild(imgwrapper);
                //card.appendChild(btn);
                container.appendChild(card);
            });
        }


});